import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import layoutHeaderAside from '@/layout/header-aside';

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

var meta = {
  auth: true
};
export default {
  path: '/order',
  name: 'order',
  meta: meta,
  component: layoutHeaderAside,
  children: [{
    path: 'purchase',
    name: 'order-purchase-index',
    component: _import('order/purchase/index'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '采购订货单'
    }),
    props: true
  }, {
    path: 'purchase/create',
    name: 'order-purchase-create',
    component: _import('order/purchase/create'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '新增采购订货单'
    }),
    props: true
  }, {
    path: 'purchase/detail/:id',
    name: 'order-purchase-detail',
    component: _import('order/purchase/detail'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '采购订货单详情'
    }),
    props: true
  }, {
    path: 'consign',
    name: 'order-consign-index',
    component: _import('order/consign/index'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '寄售订货订单'
    }),
    props: true
  }, {
    path: 'consign/create',
    name: 'order-consign-create',
    component: _import('order/consign/create'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '新增寄售订货订单'
    }),
    props: true
  }, {
    path: 'consign/detail/:id',
    name: 'order-consign-detail',
    component: _import('order/consign/detail'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '寄售订货订单详情'
    }),
    props: true
  }, {
    path: 'consign/detail/:id/:action',
    name: 'order-consign-detail-receive',
    component: _import('order/consign/detail'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '寄售订货订单详情'
    }),
    props: true
  }, {
    path: 'consign/return',
    name: 'order-consign-return-index',
    component: _import('order/consign/return/index'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '寄售退货单'
    }),
    props: true
  }, {
    path: 'consign/return/create',
    name: 'order-consign-return-create',
    component: _import('order/consign/return/create'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '新增寄售退货单'
    }),
    props: true
  }, {
    path: 'consign/return/detail/:id',
    name: 'order-consign-return-detail',
    component: _import('order/consign/return/detail'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '寄售退货单详情'
    }),
    props: true
  }, {
    path: 'after_sales',
    name: 'order-after-sales-index',
    component: _import('order/after_sales/index'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '售后订单'
    }),
    props: true
  }, {
    path: 'stockout/apply',
    name: 'order-stockout-apply-index',
    component: _import('order/stockout/apply/index'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '出库申请单'
    }),
    props: true
  }, {
    path: 'stockout/apply/create',
    name: 'order-stockout-apply-create',
    component: _import('order/stockout/apply/create'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '新增出库申请单'
    }),
    props: true
  }, {
    path: 'stockout/apply/detail/:id',
    name: 'order-stockout-apply-create',
    component: _import('order/stockout/apply/detail'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      cache: true,
      title: '出库申请单详情'
    }),
    props: true
  }]
};